module.exports = __webpack_public_path__ + "static/img/ls6.3c4ba6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls6.png
// module id = 1msE
// module chunks = 12